// extracted by mini-css-extract-plugin
export default {"label":"label__z_mPG","__view-primary":"__view-primary__tcxER","__view-secondary":"__view-secondary__yX9a_","__view-destructive":"__view-destructive__E_W_f"};